import React from 'react';
import { Link } from 'react-router-dom';
import TitleBar from '../_common/TitleBar';
import { Grid } from '@mui/material';
import Breadcrumbs from '../_common/Breadcrumbs';

const OPTitleBar = () => {
  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/orders">Orders</Link>
          <span>New Order</span>
        </Breadcrumbs>
      </Grid>
    </TitleBar>
  );
};

export default OPTitleBar;
